import { render, staticRenderFns } from "./compactTopbar.vue?vue&type=template&id=887fb9e4&scoped=true&"
import script from "./compactTopbar.vue?vue&type=script&lang=js&"
export * from "./compactTopbar.vue?vue&type=script&lang=js&"
import style0 from "./compactTopbar.vue?vue&type=style&index=0&id=887fb9e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887fb9e4",
  null
  
)

export default component.exports